<template>
  <d-container fluid>
    <d-row v-if="isLogin">
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems" />

      <d-col class="main-content offset-lg-2 offset-md-3 p-0" id="main_dc">
        <!-- Main Navbar -->
        <div id="topnav">
          <div id="topbutton" v-on:click="main_closenav">
            <a href="#" class="btn btn-white btn-animate cusbutton"
              ><i class="el-icon-caret-left"></i>CLOSE NAVBAR</a
            >
          </div>
          <main-navbar id="topnav_conect"> </main-navbar>
        </div>
        <!-- Content -->
        <slot></slot>

        <!-- Main Footer -->
        <main-footer> </main-footer>
      </d-col>
    </d-row>

    <d-row v-else>
      <d-col class="main-content" tag="main">
        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import axios from "axios";
import getSidebarItems from "@/data/sidebar-nav-items";

// Main layout components
import MainNavbar from "@/components/layout/MainNavbar/MainNavbar.vue";
import MainSidebar from "@/components/layout/MainSidebar/MainSidebar.vue";
import MainFooter from "@/components/layout/MainFooter/MainFooter.vue";
import $ from "jquery";
export default {
  name: "analytics",
  prop: {},
  components: {
    MainNavbar,
    MainSidebar,
    MainFooter,
  },
  computed: {
    isLogin: function () {
      return !(localStorage.getItem("loggedin") === null);
      //return !this.ViewMap
    },
  },
  created: function () {
    this.setHeader();
    //console.log(this.authorization);
  },
  data() {
    return {
      sidebarItems: getSidebarItems(),
    };
  },
  methods: {
    main_closenav() {
      if (this.checknavbarclose == true) {
        $("#main_dc").removeClass("offset-lg-2 offset-md-3");
        $("#aside").hide();
        $("#topnav_conect").hide();

        this.checknavbarclose = false;
      } else {
        $("#aside").show();
        $("#topnav_conect").show();
        $("#main_dc").addClass("offset-lg-2 offset-md-3");
        this.checknavbarclose = true;
      }
    },
    async refreshAccessToken() {
      return new Promise((reoslve) => {
        // console.log("start refrsh access token");
        axios
          .put(
            process.env.VUE_APP_SERVICE_URL + `api/auth/User/refresh-token`,
            {
              refreshToken: localStorage.getItem("refreshToken"),
            }
          )
          .then((response) => {
            // console.log("reponse");
            localStorage.setItem(
              "accessToken",
              response.data.result.accessToken
            );
            localStorage.setItem(
              "refreshToken",
              response.data.result.refreshToken
            );
            reoslve(response.data.result.accessToken);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    setHeader() {
      // console.log("setHeader");

      var $this = this;
      axios.interceptors.request.use((config) => {
        config.headers.authorization = "Bearer " + localStorage["accessToken"];
        return config;
      });

      axios.interceptors.response.use(
        (response) => {
          return response;
        },
        async (error) => {
          const originalRequest = error.config;
          // console.log("patch is " + error.response.config.url);

          if (
            error.response.status === 401 &&
            !originalRequest._retry &&
            error.response.config.url !=
              process.env.VUE_APP_SERVICE_URL + `api/auth/User/refresh-token`
          ) {
            originalRequest._retry = true;
            const access_token = await $this.refreshAccessToken();
            // console.log("refreshed new token", access_token);
            return axios(originalRequest);
          } else if (error.response.status === 400) {
            //do nothing
          } else {
            //logout
            localStorage.clear();
          }

          return Promise.reject(error);
        }
      );
    },
  },
};
</script>



<style scoped>
.cusbutton {
  top: 10px;
  position: absolute;
  z-index: 99999999 !important;
}

.btn:link,
.btn:visited {
  text-transform: uppercase;
  text-decoration: none;
  padding: 15px 40px;
  display: inline-block;
  border-radius: 100px;
  transition: all 0.2s;
  position: absolute;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.btn:active {
  transform: translateY(-1px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.btn-white {
  background-color: #fff;
  color: #777;
}

.btn::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 100%;
  border-radius: 100px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  transition: all 0.4s;
}

.btn-white::after {
  background-color: #fff;
}

.btn:hover::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}

.btn-animated {
  animation: moveInBottom 5s ease-out;
  animation-fill-mode: backwards;
}

@keyframes moveInBottom {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>